import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-repeatable-group-toolbar',
    standalone: false,
    templateUrl: './repeatable-group-toolbar.component.html',
    styleUrls: ['./repeatable-group-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepeatableGroupToolbarComponent {
    @Input() public title = '';
    @Input() public currentCount = 0;
    @Input() public maxRows = 1;
    @Input() public addButtonLabel = 'Agregar';
    @Input() public canAddRow = false;
    @Input() public debug = false;

    @Output() public addRowRequested = new EventEmitter<void>();
    @Output() public debugRequested = new EventEmitter<void>();
}
